import {
  createModalDataToken,
  createModalOpener
} from 'src/app/helpers/create-modal-opener';
import { TaskDto } from 'src/app/models/process/task-dto';
import { WorkItemsQaReportClientInfo } from '../work-items-qa-report-client/model/work-items-qa-report-client-info';
import { WorkItemsQaReportConfirmationComponent } from './work-items-qa-report-confirmation.component';

interface WorkItemsQaReportConfirmationInput {
  readonly clientInfo: WorkItemsQaReportClientInfo;
  readonly qaTask: TaskDto;
}

export const WORK_ITEMS_QA_REPORT_CONFIRMATION_DATA =
  createModalDataToken<WorkItemsQaReportConfirmationInput>(
    'WorkItemsQaReportConfirmationData'
  );

export const workItemsQaReportConfirmationOpener = createModalOpener(
  WorkItemsQaReportConfirmationComponent,
  WORK_ITEMS_QA_REPORT_CONFIRMATION_DATA,
  { size: 'md', backdrop: 'static' }
);
